import React from 'react';
import { Drawer as AntdDrawer } from 'antd';
import { DrawerProps } from 'antd/lib/drawer';
import classnames from 'classnames';
import CloseSvg from 'components/Icons/Close/close.svg';
import cn from './styles.module.scss';

export interface DrawerPropsType extends DrawerProps {
  children?: React.ReactNode,
}

export const Drawer = ({
  open,
  onClose,
  children,
  className,
  ...rest
}: DrawerPropsType) => (
  <AntdDrawer
    placement="right"
    onClose={onClose}
    open={open}
    rootClassName={classnames(cn.drawer, className)}
    closeIcon={<CloseSvg width={24} height={24} />}
    {...rest}
  >
    {children}
  </AntdDrawer>
);
